export default "__VITE_ASSET__9977d32f__"